import { render, staticRenderFns } from "./OtherReservationModal.vue?vue&type=template&id=0d5d2e68&scoped=true&"
import script from "./OtherReservationModal.vue?vue&type=script&lang=js&"
export * from "./OtherReservationModal.vue?vue&type=script&lang=js&"
import style0 from "./OtherReservationModal.vue?vue&type=style&index=0&id=0d5d2e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5d2e68",
  null
  
)

export default component.exports